import { EVINCED_SEVERITIES } from '@evinced-private/ui-common';

export enum PRODUCT_NAME {
	WEB_FLOW_ANALYZER = 'WEB_FLOW_ANALYZER',
	WEB_SDK = 'WEB_SDK',
	MOBILE_FLOW_ANALYZER = 'MOBILE_FLOW_ANALYZER',
	MOBILE_SDK = 'MOBILE_SDK'
}

export enum PRODUCT_DISPLAY_NAME {
	WEB_FLOW_ANALYZER = 'Web Flow Analyzer',
	WEB_SDK = 'Web SDK',
	MOBILE_FLOW_ANALYZER = 'Mobile Flow Analyzer',
	MOBILE_SDK = 'Mobile SDK'
}

export interface IAllIssue {
	id: string;
	runId: string;
	productName: PRODUCT_NAME;
	issueType: string;
	severity: EVINCED_SEVERITIES | string;
	pageTitle: string;
	pageUrl: string;
	foundBy: PRODUCT_DISPLAY_NAME;
	sessionOrTest: string;
	user: string;
}

export interface IUniqueIssue {
	id: string;
	issueId: string;
	runId: string;
	productName: PRODUCT_NAME;
	issueType: string;
	severity: EVINCED_SEVERITIES | string;
	pageTitle: string;
	pageUrl: string;
	firstSeen: string;
	lastSeen: string;
}
